import { notification } from "antd";
import React, { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { translation } from "../../../../i18n/translationConstant";
import { UserLoginSuccessResponse } from "../../../../Models/Response/Authentication/Otp";
import {
  logInWithPin,
  logInWithPinOnly,
  sendOtp,
  verifyOtp,
  verifyOtpWithFingerPrint,
} from "../../../../Services/AuthenticationServices/AuthenticationServices";
import { setCredentialsLocalStorage } from "../../../../Services/LocalStorageServices";
import { QueryParams, Routes } from "../../../../Utils/Constants/routes";
import OTPInputComponent from "../../../Common/Components/OTPModal";
import LoginSignupForm from "../Form";
import LoginSignupSidePanel from "../Greetings";
import "./index.css";
import WebviewOTP from "../../../Common/Components/OTPModal/WebviewOTPInputComponent";
import WebviewOTPInputComponent from "../../../Common/Components/OTPModal/WebviewOTPInputComponent";

export const Context = createContext({});

const LoginComponent: React.FC = () => {
  const { t } = useTranslation();
  const { push, location } = useHistory();
  const [isOTPModalVisible, setOTPModalVisibility] = useState(false);
  const [isLoginWithPin, setIsLoginWithPin] = useState(true);
  const [otpUniqueID, setOTPUniqueId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const redirect: any = location.state;

  const [slide, setSlide] = useState(0);

  const closeModal = () => {
    setOTPModalVisibility(false);
  };

  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query: any = useQuery();

  const state: any = location.state;

  // const login = (values: any) => {
  //   if (isLoginWithPin) {
  //     logInWithPin(values)
  //       .then((res) => res.data)
  //       .then((res: UserLoginSuccessResponse) => {
  //         notification.success({
  //           message: t(translation.lblLoginSuccess),
  //         });

  //         setCredentialsLocalStorage(res);
  //         if (query && query.get(QueryParams.redirect)) {
  //           push(query.get(QueryParams.redirect) + (state.search ?? ""));
  //         } else {
  //           push(Routes.consent);
  //         }
  //       });
  //   } else {
  //     setPhoneNumber(values.phoneNumber);
  //     sendOtp(values)
  //       .then((res) => res.data)
  //       .then((res) => {
  //         setOTPModalVisibility(true);
  //         setOTPUniqueId(res);
  //       });
  //   }
  // };

  const login = (values: any) => {
    logInWithPinOnly(values)
        .then((res) => res.data)
        .then((res: UserLoginSuccessResponse) => {
         
          setPhoneNumber(values.phoneNumber);
          sendOtp(values)
          .then((res) => res.data)
          .then((res) => {
            setOTPModalVisibility(true);
            setOTPUniqueId(res);
          });
        });
  };

  const userLoginOtp = (otp: string) => {
    // verifyOtp({
    verifyOtpWithFingerPrint({
      code: otp,
      phone_number: phoneNumber,
      grant_type: "password",
      otpUniqueID,
    })
      .then((res) => res.data)
      .then((res: UserLoginSuccessResponse) => {
        setOTPModalVisibility(false);
        notification.success({
          message: t(translation.lblLoginSuccess),
        });

        setCredentialsLocalStorage(res);

        if (query && query.get(QueryParams.redirect)) {
          push(query.get(QueryParams.redirect) + (state.search ?? ""));
        } else {
          push(Routes.consent);
        }
      });
  };

  const isLoginwithPin = (isLoginWithpin: boolean) => {
    setIsLoginWithPin(isLoginWithpin);
  };

  const signUp = () => {
    push(Routes.signup);
  };

  // useEffect(() => {
  //   if (redirect?.phoneNumber) {
  //     // setIsLoginWithPin(true); 
  //     setPhoneNumber(redirect.phoneNumber);
      
  //     console.log("Redirect FIU name:, ", redirect.fiuName);
  //     // Trigger OTP automatically
  //     sendOtp({ phoneNumber: redirect.phoneNumber })
  //       .then((res) => res.data)
  //       .then((res) => {
  //         setOTPUniqueId(res);
  //       });
  //   }
  // }, [state]);


  return (
    <Context.Provider value={{ slide, setSlide }}>
      <OTPInputComponent
        onCancel={closeModal}
        isOpen={isOTPModalVisible}
        onOtpSubmit={userLoginOtp}
        okText={t(translation.lblConfirm)}
        title={t(translation.lblEnterOTP)}
        // tslint:disable-next-line: jsx-no-lambda
        onResend={() => login({ phoneNumber })}
        mobileNumber={phoneNumber}
      />
      <div className="loginRoot">
        <div
          className={`${
            slide === 0
              ? "sliderCssBorder1"
              : slide === 1
              ? "sliderCssBorder2"
              : "sliderCssBorder3"
          } sliderCss`}
        >
          
          {(redirect?.phoneNumber) ?
            <>  
              <LoginSignupSidePanel type="webview" />
              {/* <WebviewOTPInputComponent
                isOpen={true}
                onOtpSubmit={userLoginOtp}
                okText={t(translation.lblConfirm)}
                title={t(translation.lblEnterOTP)}
                // onResend={() => login({ phoneNumber })}
                onResend={() => {
                  sendOtp({ phoneNumber })
                  .then((res) => res.data)
                  .then((res) => {
                    setOTPUniqueId(res);
                  });
                }}
                mobileNumber={phoneNumber}
              /> */}
              <LoginSignupForm
                phoneNumber={!!redirect && redirect.phoneNumber}
                formType={"LOGIN"}
                formSubmit={login}
                buttonSubSectionText={t(translation.lblDontHaveAccount)}
                buttonSubSectionButton={t(translation.lblCreateAccount)}
                buttonText={t(translation.lblSendOTP)}
                subButtonClick={signUp}
                isLoginWithPin={isLoginwithPin}
              />
            </>
          :
            <>  
              <LoginSignupSidePanel type="login" />
              <LoginSignupForm
                phoneNumber={!!redirect && redirect.phoneNumber}
                formType={"LOGIN"}
                formSubmit={login}
                buttonSubSectionText={t(translation.lblDontHaveAccount)}
                buttonSubSectionButton={t(translation.lblCreateAccount)}
                buttonText={t(translation.lblSendOTP)}
                subButtonClick={signUp}
                isLoginWithPin={isLoginwithPin}
              />
            </>
          }
        </div>
      </div>
    </Context.Provider>
  );
};

export default LoginComponent;
